autoslash.createNamespace("autoslash.address");
autoslash.register(autoslash.address);

autoslash.address.initialize = function (element) {
    "use strict";
    var $countries = element.find("[data-autoslash-country]");

    $countries.each(function() {
        var statesElementId = $(this).data("autoslash-country");
        var states = $("#" + statesElementId);
        if (states.find("option").length === 1)
        {
            states.prop("disabled", true);
        }
    });

    $countries.change(function() {
        var statesElementId = $(this).data("autoslash-country");
        var service = $(this).data("autoslash-country-service");
        var states = $("#" + statesElementId);
        var countries = $(this);
        states.children("option:not(:first)").remove();
        states.prop("disabled", true);
        if (countries.val()) {
            $.ajax({
                url: service,
                type: "POST",
                dataType: "json",
                contentType: "application/json",
                async: true,
                data: JSON.stringify({ countryCode: countries.val() }),
                success: function(results) {
                    if (results && results.length > 0) {
                        for (var i = 0; i < results.length; i++) {
                            states.append("<option value='" + results[i].Value + "'>" + results[i].Text + "</option>");
                        }
                        states.prop("disabled", false);
                    }
                }
            });
        }
    });
}